import React, { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';
import { MEMBER_URL, isProdEnv } from '../../../../../config/Master';
import { ScanText } from '../CameraPermissionStyle';
import { generateMagicLink } from '../../../../../sdk';
import { RootState } from '../../../../../store';
import { toaster } from '../../../../../common';
import LoadingBackdrop from '../../../../../atoms/loader/LoadingBackdrop';
import { useJoin } from '../../../../../contexts/JoinContext';
import { QRCodeContainer, qrCodeWrraper } from '../../SelfieVerificationStyle';

interface QRCodeProps {
  customStyle?: React.CSSProperties;
  scanText?: null | string;
  customTextStyle?: React.CSSProperties;
  isJoinFlow: boolean;
  showLoadingBg?: boolean;
  customLoaderStyle?: React.CSSProperties;
}

const MagicQRCode: React.FC<QRCodeProps> = ({
  customStyle,
  scanText,
  customTextStyle,
  isJoinFlow,
  showLoadingBg,
  customLoaderStyle,
}) => {
  const { hash_id } = useSelector((state: RootState) => state.profile);
  const { currentStepIndex, stepsFormData } = useJoin();
  const [qrCodeEmail, setQRCodeEmail] = useState<string>('');
  const [qrCodeToken, setQRCodeToken] = useState<string>('');
  const [showLoader, setShowLoader] = useState<boolean>(false);

  useEffect(() => {
    const handleGenerateMagicLink = async () => {
      try {
        setShowLoader(true);
        const result = await generateMagicLink(hash_id);

        if (result?.data?.response) {
          setQRCodeEmail(result.data.response.email);
          setQRCodeToken(result.data.response.token);
        }
        setShowLoader(false);
      } catch (error) {
        console.warn('error', error);
        setShowLoader(false);
        toaster.error("Something wen't wrong to get the QR Code");
      }
    };

    handleGenerateMagicLink();
  }, []);

  const step =
    stepsFormData.length > 0 && stepsFormData[0].account_type === 1 ? currentStepIndex + 1 : currentStepIndex;

  const qrString = `email=${encodeURIComponent(qrCodeEmail)}&token=${qrCodeToken}&source=selfie-qr`;

  const magicLink = isJoinFlow
    ? `${MEMBER_URL}/join?${qrString}&step=${step}`
    : `${MEMBER_URL}/login?${qrString}&from=member`;

  return (
    <>
      <QRCodeContainer style={customStyle}>
        {!isProdEnv && <input type="hidden" id="qa_qr" value={magicLink} />}
        <LoadingBackdrop active={showLoader} showLoadingBg={showLoadingBg || false} customStyle={customLoaderStyle} />
        {qrCodeEmail && qrCodeToken && (
          <>
            <QRCode style={qrCodeWrraper} value={magicLink} />
            <ScanText customStyle={customTextStyle}>
              {scanText || `Scan this QR Code to continue your Selfie Verification on another device`}
            </ScanText>
          </>
        )}
      </QRCodeContainer>
    </>
  );
};

export default MagicQRCode;
